import { Alert, Button, Checkbox, DatePicker, Form, Input, InputNumber, Modal, Select,Row,Col, Divider, TreeSelect } from 'antd'
import { useForm } from 'antd/lib/form/Form'
import * as React from 'react'
import { useEffect, useRef, useState } from 'react'
import { useHistory } from 'react-router'
import { DspBean, ListPagination, PublisherBean } from 'src/api/api'
import { formDataLoader, FormDataType } from 'src/util/FormDataLoader'
import dealApi from './DealApi'
import { DEALS_PAGE_SIZE, getIabCategoriesAsTree, resolveIabDefaultsChange, stripSelectDefaultsValue, toDealEnvironment } from 'src/util/Util'
import DealDomainListCard from './DealDomainListCard'

const FormItem = Form.Item
const Option = Select.Option

interface Props {

}

const formInfoItems: FormDataType[] = [
    FormDataType.Publishers,
    FormDataType.DealTypes,
    FormDataType.DealStatus,
    FormDataType.DspList,
    FormDataType.TimeZones,
    FormDataType.DeviceTypes,
    FormDataType.MediaTypes,
    FormDataType.AdSizes,
    FormDataType.IabCategories,
    FormDataType.Countries,
]

const DealCreate: React.FC<Props> = () => {

    const [form] = useForm()
    const [error, setError] = useState()
    const history = useHistory()

    const [startDate, setStartDate] = useState('')
    const [endDate, setEndDate] = useState('')
    const [environmentType, setEnvironmentType] = useState<string[]>(['APP', 'WEB'])
    const [environmentError, setEnvironmentError] = useState('')
    const [info, setInfo] = useState({
        publishers: [],
        dealTypes: [],
        dealStatus: [],
        dspList: [],
        timezones:[],
        deviceTypes:[],
        mediaTypes:[],
        adSizes:[],
        iabCategories:[],
        countries:[]
    })

    const [allClassification, setAllClassification] = useState(false)
    const [acceptAllMobileAppIds, setAcceptAllMobileAppIds] = useState(false)

    // ─── Domains state ──────────────────────────────────────────────────────
    const [domains, setDomains] = useState<string[]>([])
    const [domainsCollapsed, setDomainsCollapsed] = useState(false)

    // ─── Mobile App IDs state ───────────────────────────────────────────────
    const [mobileAppIds, setMobileAppIds] = useState<string[]>([])
    const [mobileAppsCollapsed, setMobileAppsCollapsed] = useState(false)

    const iabPrevRef = useRef<number[]>([])

    const determineTargetPage = async () => {
        try {
            const listResponseDealBean = await dealApi.list(DEALS_PAGE_SIZE, 1)
            const pagination = listResponseDealBean.pagination as ListPagination | undefined
            const totalPagesFromApi = pagination?.totalPages
            if (totalPagesFromApi && totalPagesFromApi > 0) {
                return totalPagesFromApi
            }
            const totalItems = pagination?.total ?? 0
            const pageSize = pagination?.size ?? DEALS_PAGE_SIZE
            if (pageSize > 0) {
                return Math.max(1, Math.ceil(totalItems / pageSize))
            }
        } catch (error) {
            // ignore and fallback to first page
        }
        return 1
    }


    const formatWseat = (arr) => {
  const obj = {};
  arr.forEach((item) => {
    if (item.dsp) obj[item.dsp] = item.seats;
  });
  return obj;
};


    const onChangeIab = (value: number[]) => {
        const next = resolveIabDefaultsChange(value || [], iabPrevRef.current, info.iabCategories as any)
        iabPrevRef.current = next
        form.setFieldsValue({ ['iabCategories']: next })
        return next
    }

    const handleSubmit = () => {
        if (environmentType.length === 0) {
            setEnvironmentError('Please select at least one environment')
            return
        }
        setEnvironmentError('')
        const wseatErrs = wseats.map(row => !row.dsp);
        if (wseatErrs.some(Boolean)) {
            setWseatErrors(wseatErrs);
            return;
        }
        setWseatErrors(wseatErrs);
        form.validateFields().then(values => {
values.wseat = formatWseat(wseats);
            const {
                // preferredBuyer,
                fixedCpm,
                firstLookWindow,
                fallbackToOpenAuction,
                fallbackFloorPrice,
                bidIncrement,
                volumeCommitment,
                deliveryGuarantee,
                dealType,
                ...restValues
            } = values;

            let dealTypeConfiguration = {};

            if (dealType === 'Preferred') {
                dealTypeConfiguration = {
                    // preferredBuyer: preferredBuyer || null,
                    fixedCpm: fixedCpm || null,
                    firstLookWindow: firstLookWindow ?? null,
                    fallbackToOpenAuction: fallbackToOpenAuction || false
                };
            } else if (dealType === 'FirstPricePvt') {
                dealTypeConfiguration = {};
            } else if (dealType === 'SecPricePvt') {
                dealTypeConfiguration = {
                    bidIncrement: bidIncrement || null
                };
            } else if (dealType === 'FixedPrice') {
                dealTypeConfiguration = {
                    volumeCommitment: volumeCommitment || null,
                    deliveryGuarantee: deliveryGuarantee || null
                };
            }

            // Direct allow-list management — plain string arrays, no classification
            const domainList: string[] = allClassification ? [] : domains
            const mobileAppIdList: string[] = acceptAllMobileAppIds ? [] : mobileAppIds

            const environment = toDealEnvironment(environmentType)
            const payload = {
                ...restValues,
                iabCategories: stripSelectDefaultsValue(restValues.iabCategories),
                dealType,
                startDate,
                endDate,
                dealTypeConfiguration,
                environment,
                domains: domainList,
                acceptAllDomains: allClassification,
                mobileAppIds: mobileAppIdList,
                acceptAllMobileAppIds
            };
            dealApi
                .create(payload)
                .then(async ()=>{
                    success();
                    const page = await determineTargetPage()
                    history.push(`/deal?page=${page}`)
                })
                .catch(err => {
                    setError(err.error);
                })
        });
    };
    const success = () => {
        Modal.success({
          content: 'Created Successfully',
        });
      };
    const loadFormData = async () => {
        try {
            let formInfo = await formDataLoader(...formInfoItems)
            setInfo(formInfo as any)
        } catch (e) {
            setError(e.error)
        }
    }

    // ─── Domain handlers ────────────────────────────────────────────────────
    const handleAddDomain = (value: string) => setDomains(prev => [...prev, value])
    const handleUploadDomains = (file: File) => {
        const reader = new FileReader()
        reader.onloadend = () => {
            const lines = (reader.result as string).split('\n').map(l => l.trim()).filter(Boolean)
            setDomains(prev => {
                const existingLower = new Set(prev.map(d => d.toLowerCase()))
                return [...prev, ...lines.filter(d => !existingLower.has(d.toLowerCase()))]
            })
        }
        reader.readAsText(file)
    }
    const handleRemoveDomain = (index: number) =>
        setDomains(prev => prev.filter((_, i) => i !== index))
    const handleClearAllDomains = () => {
        Modal.confirm({
            title: 'Clear all domains?',
            content: 'This cannot be undone.',
            okText: 'Clear All',
            okButtonProps: { danger: true },
            cancelText: 'Cancel',
            onOk: () => setDomains([]),
        })
    }

    // ─── Mobile App ID handlers ─────────────────────────────────────────────
    const handleAddMobileAppId = (value: string) => setMobileAppIds(prev => [...prev, value])
    const handleUploadMobileAppIds = (file: File) => {
        const reader = new FileReader()
        reader.onloadend = () => {
            const lines = (reader.result as string).split('\n').map(l => l.trim()).filter(Boolean)
            setMobileAppIds(prev => {
                const existingLower = new Set(prev.map(d => d.toLowerCase()))
                return [...prev, ...lines.filter(d => !existingLower.has(d.toLowerCase()))]
            })
        }
        reader.readAsText(file)
    }
    const handleRemoveMobileAppId = (index: number) =>
        setMobileAppIds(prev => prev.filter((_, i) => i !== index))
    const handleClearAllMobileAppIds = () => {
        Modal.confirm({
            title: 'Clear all mobile app IDs?',
            content: 'This cannot be undone.',
            okText: 'Clear All',
            okButtonProps: { danger: true },
            cancelText: 'Cancel',
            onOk: () => setMobileAppIds([]),
        })
    }

    useEffect(() => {
        loadFormData()
    }, [])

    const handleSelectAll = (value: any) => {
        if (value && value.length && value.includes('__all')) {
            if (value.length === info.dspList.length + 1) {
                return []
            }
            return [...(info.dspList.map((el: DspBean) => el.id))]
        }
        return value
    }


    const [wseats, setWseats] = useState([
  { dsp: "", seats: [] }
]);
const [wseatErrors, setWseatErrors] = useState<boolean[]>([false]);

console.log(wseats,"wseats")


const addDSP = () => {
  setWseats([...wseats, { dsp: "", seats: [] }]);
  setWseatErrors([...wseatErrors, false]);
};
const removeDSP = (index) => {
  const copy = [...wseats];
  copy.splice(index, 1);
  setWseats(copy);
  const errCopy = [...wseatErrors];
  errCopy.splice(index, 1);
  setWseatErrors(errCopy);
};

const handleDSPChange = (index, value) => {
  const copy = [...wseats];
  copy[index].dsp = value;
  setWseats(copy);
  if (value) {
    const errCopy = [...wseatErrors];
    errCopy[index] = false;
    setWseatErrors(errCopy);
  }
};
const handleSeatInput = (index, value) => {
  const copy = [...wseats];
  copy[index].seats = value;
  setWseats(copy);
  if (copy[index].dsp) {
    const errCopy = [...wseatErrors];
    errCopy[index] = false;
    setWseatErrors(errCopy);
  }
};

      
    return (
        <Form
            style={{
                maxWidth: '1200px'
            }}
            onFinish={handleSubmit}
            form={form}
        >
            {error ? <Alert message={error} type="error" /> : null}
            <Row gutter={24}>

             <Col span={12}>
                <div style={{ paddingRight: '12px' }}>
                
            <FormItem
                name="publisherIds"
                label="Publishers"
                labelCol={{ span: 8 }}
                wrapperCol={{ span: 16 }}
                tooltip="Available Publishers"
                rules={[
                    {
                        required: true,
                        message: 'Please select Publisher'
                    }
                ]}
            >
                <Select
                    mode="multiple"
                    optionFilterProp="title"
                    showSearch
                    allowClear
                    placeholder="Select Publishers"
                    onChange={(value: any) => {
                        if (value && value.includes('__all')) {
                            if (value.length === info.publishers.length + 1) {
                                form.setFieldsValue({ publisherIds: [] });
                            } else {
                                form.setFieldsValue({ publisherIds: info.publishers.map((p: PublisherBean) => p.id) });
                            }
                        } else {
                            form.setFieldsValue({ publisherIds: value.filter((v: any) => v !== '__all') });
                        }
                    }}
                >
                    <Option key="__all" value="__all" title="Select All">Select All</Option>
                    {info.publishers.map((item: PublisherBean) =>
                        <Option title={item.name} key={item.id} value={item.id as number}>{item.name}</Option>)}
                </Select>
            </FormItem>
            <FormItem
                name="name"
                labelCol={{ span: 8 }}
                wrapperCol={{ span: 16 }}
                rules={[
                    {
                        required: true,
                        message: 'Please input Deal Name'
                    },
                    {
                        max: 255,
                        message: 'Name cannot be longer that 255 characters'
                    }
                ]}
                label="Name"
                tooltip={'Name'}
            >
                <Input />
            </FormItem>

                <FormItem
                    name="dealType"
                    label="Deal Type"
                    labelCol={{ span: 8 }}
                    wrapperCol={{ span: 16 }}
                    tooltip="Deal Type"
                    rules={[
                        {
                            required: true,
                            message: 'Please select Deal Type'
                        }
                    ]}
                >
                    <Select
                        optionFilterProp="title"
                        showSearch
                        allowClear
                        placeholder="Select Deal Type"
                    >
                        <Option value="">Select Type</Option>
                        {info.dealTypes.map((item: any) =>
                            <Option title={item.name} key={item.value} value={item.value}>{item.name}</Option>)}
                    </Select>
                </FormItem>

            

        <FormItem
    label="Dates"
    labelCol={{ span: 8 }}
    wrapperCol={{ span: 16 }}
    tooltip={'Start and End date of Deal works'}
    required={true}
>
    <div style={{ display: 'flex', gap: '16px' }}>
        <FormItem
            name="startDate"
            className="ant-item ant-item-first"
            rules={[
                {
                    required: true,
                    message: 'Please select start date'
                }
            ]}
        >
            <DatePicker 
                onChange={(moment, value: any) => setStartDate(value)} 
                placeholder="Start date"
                disabledDate={(current) =>
                    current && current.valueOf() < Date.now() - 86400000
                }
            />
        </FormItem>

        <FormItem
            name="endDate"
            className="ant-item ant-item-second"
            rules={[
                {
                    required: true,
                    message: 'Please select end date'
                }
            ]}
        >
            <DatePicker 
                onChange={(moment, value: any) => setEndDate(value)} 
                placeholder="End date"
                disabledDate={(current) => {
                    const today = new Date().setHours(0, 0, 0, 0);
                    if (startDate) {
                        const start = new Date(startDate).setHours(0, 0, 0, 0);
                        return current && current.valueOf() < Math.max(start, today);
                    }
                    return current && current.valueOf() < today;
                }}
            />
        </FormItem>
    </div>
</FormItem>


         <FormItem
    name="dealStatus"
    label="Deal Status"
    labelCol={{ span: 8 }}
    wrapperCol={{ span: 16 }}
    tooltip="Deal Status"
    initialValue="Draft"
    rules={[
        {
            required: true,
            message: 'Please select Deal Status'
        }
    ]}
>
    <Select
        optionFilterProp="title"
        showSearch
        allowClear={!!form.getFieldValue('id')}
        placeholder="Select Deal Status"
        disabled={!form.getFieldValue('id')}
    >
        {(!form.getFieldValue('id')
            ? info.dealStatus.filter((item: any) => item.value === 'Draft')
            : info.dealStatus
        ).map((item: any) => (
            <Option title={item.name} key={item.value} value={item.value}>
                {item.name}
            </Option>
        ))}
    </Select>
</FormItem>
 

            

  <FormItem label="WSeats" labelCol={{ span: 8 }}
    wrapperCol={{ span: 16 }}>
  {wseats.map((row, index) => (
    <div key={index} style={{ marginBottom: 15 }}>
      <div style={{ display: "flex", gap: "10px", alignItems: "flex-start" }}>

        <div style={{ display: 'flex', flexDirection: 'column' }}>
          <Select
            style={{ width: 180 }}
            placeholder="Select DSP"
            value={row.dsp}
            onChange={(val) => handleDSPChange(index, val)}
            status={wseatErrors[index] ? 'error' : undefined}
          >
            {info.dspList.map((item : any) => (
              <Select.Option key={item.id} value={item.id}>{item.name}</Select.Option>
            ))}
          </Select>
          {wseatErrors[index] && (
            <div style={{ color: '#ff4d4f', fontSize: 12, marginTop: 4 }}>
              Please select a DSP
            </div>
          )}
        </div>

        <Select
          mode="tags"
          style={{ width: 300 }}
          placeholder="Type seat ID & Enter"
          value={row.seats}
          onChange={(val) => handleSeatInput(index, val)}
        />

        {wseats.length > 1 && (
          <Button danger onClick={() => removeDSP(index)}>Remove</Button>
        )}
      </div>
    </div>
  ))}

  <Button type="primary" onClick={addDSP}>+ Add DSP</Button>
</FormItem>

<div style={{ width: "90%",marginLeft:"60px" }}>
  <Divider  style={{display:"flex",justifyContent:"flex-end"}} />
</div>

            
            <div style={{ marginBottom: '16px' ,display:'flex', justifyContent:'flex-end',width : "35%"}}>
                <h3 style={{ margin: 0, fontSize: '16px', fontWeight: 600 }}>Targeting Fields</h3>
            </div>
 
          
          
               <FormItem
                name="adUnitId"
                labelCol={{ span: 8 }}
                wrapperCol={{ span: 16 }}
                label="Ad Unit IDs"
                tooltip={'Ad Unit IDs'}
            >
                <Select
                    mode="tags"
                    placeholder="Type Ad Unit ID & Enter"
                    style={{ width: '100%' }}
                />
            </FormItem>
           
           
           

    
            <FormItem
                name="geoRegion"
                labelCol={{ span: 8 }}
                wrapperCol={{ span: 16 }}
                label="Geo Countries"
                tooltip="Geo Countries"
            >
                 <Select
                        mode="multiple"
                        showSearch
                        allowClear
                        placeholder="Select Countries"
                        optionFilterProp="children"
                        filterOption={(input, option) =>
                            (option?.children as unknown as string)?.toLowerCase().indexOf(input.toLowerCase()) >= 0
                        }
                    >
                        {info.countries.map((item: any) => (
                            <Option key={item.id} value={item.id}>{item.name}</Option>
                        ))}
                    </Select>
            </FormItem>
            

           <FormItem
    name="adFormat"
    labelCol={{ span: 8 }}
    wrapperCol={{ span: 16 }}
    label="Ad Formats"
    tooltip={'Ad Formats'}
>
    <Select
        mode="multiple"
        showSearch
        allowClear
        placeholder="Select Ad Formats"
        onChange={() => {
            form.setFieldsValue({ adSize: undefined });
        }}
    >
        {info.mediaTypes.map((item: any) => (
            <Option key={item.value} value={item.value}>{item.name}</Option>
        ))}
    </Select>
</FormItem>
            <FormItem
                name="deviceType"
                labelCol={{ span: 8 }}
                wrapperCol={{ span: 16 }}
                label="Device Types"
                tooltip={'Device Types'}
            >
                 <Select
                        mode="multiple"
                        showSearch
                        allowClear
                        placeholder="Select Device Types"
                    >
                        {info.deviceTypes.map((item: any) => (
                            <Option key={item.value} value={item.value}>{item.name}</Option>
                        ))}
                    </Select>
            </FormItem>
         <Form.Item noStyle shouldUpdate={(prevValues, currentValues) => prevValues.adFormat !== currentValues.adFormat}>
    {({ getFieldValue }) => {
        const adFormat = getFieldValue('adFormat');
        return (
            <FormItem
                name="adSize"
                labelCol={{ span: 8 }}
                wrapperCol={{ span: 16 }}
                label="Ad Sizes"
                tooltip={'Ad Sizes'}
            >
                <Select
                    mode="multiple"
                    showSearch
                    allowClear
                    placeholder="Select Ad Sizes"
                    disabled={!adFormat || adFormat.length === 0}
                >
                    {info.adSizes.map((item: any) => (
                        <Option key={item.data.id} value={item.data.id}>{item.data.name}</Option>
                    ))}
                </Select>
            </FormItem>
        );
    }}
</Form.Item>

            <FormItem
                name="iabCategories"
                labelCol={{ span: 8 }}
                wrapperCol={{ span: 16 }}
                label="IAB Categories"
                tooltip={'IAB Categories'}
            >
                <TreeSelect
                    allowClear
                    treeCheckable
                    showCheckedStrategy="SHOW_ALL"
                    style={{ width: '100%' }}
                    dropdownStyle={{ maxHeight: '400px', overflow: 'auto' }}
                    placeholder="Select IAB categories"
                    onChange={onChangeIab}
                    treeData={getIabCategoriesAsTree(info.iabCategories as any)}
                    treeNodeFilterProp="title"
                />
            </FormItem>
                </div>
                </Col>

<Col span={12}>
<div style={{ paddingLeft: '12px' }}>   
     <h3 style={{ color: '#595959', marginBottom: '8px' }}>Configuration Fields</h3>
              <Form.Item noStyle shouldUpdate={(prevValues, currentValues) => prevValues.dealType !== currentValues.dealType}>
                {({ getFieldValue }) => {
                    const dealType = getFieldValue('dealType');
                    if (!dealType || dealType === '') {
                        return (
                                <div>
                                    <p style={{ color: '#8c8c8c', margin: 0 }}>Select a deal type to see configuration options</p>
                                </div>
                        );
                    }
                    
                    if (dealType === 'FirstPricePvt') {
                        return (
                                             <FormItem
                name="bidFloor"
                label="Bid Floor Price"
                tooltip="Minimum bid for this impression expressed in CPM"
                rules={[{ required: true, message: 'Please set cost' }]}

                >
                <InputNumber step={0.01} min={0} />
            </FormItem>
                        );
                    }
                    
                    if (dealType === 'Preferred') {
                        return (
                            <>
                                <FormItem
                                    name="fixedCpm"
                                    label="Fixed CPM"
                                    // labelCol={{ span: 10 }}
                                    // wrapperCol={{ span: 14 }}
                                    tooltip={'Fixed CPM'}
                                    required={true}
                                    rules={[
                                        {
                                            required: true,
                                            message: 'Fixed CPM is required for Preferred deals'
                                        }
                                    ]}
                                >
                                    <InputNumber step={0.01} min={0} style={{ width: '100%' }} />
                                </FormItem>
                                <FormItem
                                    name="fallbackToOpenAuction"
                                    label="Fall Back to Open Auction"
                                    valuePropName="checked"
                                    initialValue={false}
                                    tooltip={'Enable fallback to open auction'}
                                >
                                    <Checkbox />
                                </FormItem>
                            </>
                        );
                    }
                    
                    if (dealType === 'SecPricePvt') {
                        return (
                            <>
                            <FormItem
                                name="bidIncrement"
                                label="Bid Increment"
                                tooltip={'Bid Increment'}
                                required={true}
                                rules={[
                                    {
                                        required: true,
                                        message: 'Bid Increment is required for SecPricePvt deals'
                                    }
                                ]}
                                >
                                <InputNumber step={0.01} min={0} style={{ width: '100%' }} />
                            </FormItem>
                              <FormItem
                name="bidFloor"
                label="Bid Floor Price"
                tooltip="Minimum bid for this impression expressed in CPM"
                rules={[{ required: true, message: 'Please set cost' }]}

                >
                <InputNumber step={0.01} min={0} />
            </FormItem>
                </>
                        )
                    }
                    
                    if (dealType === 'FixedPrice') {    
                        return (
                            <>
                                <FormItem
                                    name="volumeCommitment"
                                    label="Volume Commitment"
                                    required={true}
                                    rules={[
                                        {
                                            required: true,
                                            message: 'Volume Commitment is required for Fixed Price deals'
                                        }
                                    ]}
                                >
                                    <InputNumber min={0} />
                                </FormItem>
                                <FormItem
                                    name="deliveryGuarantee"
                                    label="Delivery Guarantee"
                                    required={true}
                                    rules={[
                                        {
                                            required: true,
                                            message: 'Delivery Guarantee is required for Fixed Price deals'
                                        }
                                    ]}
                                >
                                    <InputNumber min={0} />
                                </FormItem>

                                              <FormItem
                name="bidFloor"
                label="Bid Floor Price"
                tooltip="Minimum bid for this impression expressed in CPM"
                rules={[{ required: true, message: 'Please set cost' }]}

                >
                <InputNumber step={0.01} min={0} />
            </FormItem>
                            </>
                        );
                    }
                    
                    return null;
                }}
            </Form.Item>
</div>
</Col>

            </Row>

            <Row gutter={24}>
                <Col span={24}>
                    <div style={{ paddingRight: '12px' }}>
                        <FormItem
                            label="Allowed Domains"
                            labelCol={{ span: 4 }}
                            wrapperCol={{ span: 20 }}
                tooltip={'Deal allowed domains'}
            >
                <DealDomainListCard
                    title="Web Domains"
                    subtitle="Manage allowlist entries"
                    items={domains}
                    acceptAll={allClassification}
                    collapsed={domainsCollapsed}
                    onToggleCollapse={() => setDomainsCollapsed(v => !v)}
                    onAcceptAllChange={checked => {
                        setAllClassification(checked)
                        if (checked) setDomains([])
                    }}
                    onAdd={handleAddDomain}
                    onUpload={handleUploadDomains}
                    onRemoveItem={handleRemoveDomain}
                    onClearAll={handleClearAllDomains}
                />
            </FormItem>

            <FormItem
                label="Allowed Mobile App IDs"
                labelCol={{ span: 4 }}
                wrapperCol={{ span: 20 }}
                tooltip={'Deal allowed mobile app IDs'}
            >
                <DealDomainListCard
                    title="MobileApp ID"
                    subtitle="Manage allowlist entries"
                    items={mobileAppIds}
                    acceptAll={acceptAllMobileAppIds}
                    collapsed={mobileAppsCollapsed}
                    onToggleCollapse={() => setMobileAppsCollapsed(v => !v)}
                    onAcceptAllChange={checked => {
                        setAcceptAllMobileAppIds(checked)
                        if (checked) setMobileAppIds([])
                    }}
                    onAdd={handleAddMobileAppId}
                    onUpload={handleUploadMobileAppIds}
                    onRemoveItem={handleRemoveMobileAppId}
                    onClearAll={handleClearAllMobileAppIds}
                />
            </FormItem>

            <FormItem
                label="Environment"
                required
                labelCol={{ span: 4 }}
                wrapperCol={{ span: 20 }}
                tooltip={'Select the environment(s) for the Deal'}
                validateStatus={environmentError ? 'error' : undefined}
                help={environmentError || undefined}
            >
                <Checkbox.Group
                    value={environmentType}
                    onChange={(val: any) => {
                        setEnvironmentType(val)
                        if (val.length > 0) setEnvironmentError('')
                    }}
                    options={[
                        { label: 'Web', value: 'WEB' },
                        { label: 'App', value: 'APP' },
                    ]}
                />
            </FormItem>
                    </div>
                </Col>
            </Row>

            <Row>
                <Col span={24}>
                    <FormItem style={{ textAlign: 'center', marginTop: '20px' }}>
                        <Button
                            style={{
                                width: '120px',
                                marginRight: '12px'
                            }}
                            type="primary"
                            htmlType="submit"
                        >
                            Create
                        </Button>
                        <Button 
                            style={{
                                width: '120px'
                            }} 
                            type="primary" 
                            danger 
                            htmlType="button" 
                            onClick={history.goBack}
                        >
                            Cancel
                        </Button>
                    </FormItem>
                </Col>
            </Row>

        </Form>
    );
}

export default DealCreate;